import { render } from "./NextSectionTips.vue?vue&type=template&id=6cfb1240&scoped=true"
import script from "./NextSectionTips.vue?vue&type=script&lang=js"
export * from "./NextSectionTips.vue?vue&type=script&lang=js"

import "./NextSectionTips.vue?vue&type=style&index=0&id=6cfb1240&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfb1240"]])

export default __exports__